module.exports = __webpack_public_path__ + "img/drag-to-answer-white.3311021b.png";